import React from "react";
import {
  View,
  Dimensions,
  Text,
  FlatList,
} from "react-native";

import { useDispatch } from "react-redux";
import { getConfig } from "../utils/commonredux/commonRedux.action";
import { usePolling } from "../common/usePolling";
import { maintanence_img } from "../utils/images";
import { Color, globalFontStyle } from "../assets";
import Colors from "../assets/Color/Colors";
import { SafeAreaView } from "react-native-safe-area-context";
import FastImage from "../common/FastImage";
import { globalConfigurableData } from "../utils/globalConstant";

const Maintanence = ({}) => {
  const dispatch = useDispatch();

  const handleRefresh = async (e) => {
    dispatch(getConfig());
  };

  usePolling(
    () => {
      dispatch(getConfig());
    },
    10000,
    true
  );

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: Color.bgWhite,
        //marginVertical: 200,
      }}
    >
      <FlatList
        scrollEnabled={false}
        style={{ flexGrow: 1 }}
        data={[]}
        ListHeaderComponent={() => {
          return (
            <View
              style={{
                height: Dimensions.get("window").height,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  position: "absolute",
                  top: 0,
                  height: 110,
                  paddingTop: 30,
                  width: "100%",
                  backgroundColor: Colors.bgWhite,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FastImage
                  style={{
                    height: 30,
                    width: 80,
                  }}
                  source={globalConfigurableData?.logoUrl()}
                />
              </View>
              <View
                style={{
                  marginTop: -100,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FastImage
                  style={{ height: 200, width: 200, marginBottom: 0 }}
                  source={maintanence_img()}
                />
                <Text
                  style={[globalFontStyle.appFontTitle, { color: Color.blue1 }]}
                >
                  We should be back shortly
                </Text>
                <View style={{ marginTop: 10 }}>
                  <Text
                    style={[
                      globalFontStyle.appFontSubText,
                      {
                        paddingHorizontal: 30,
                        textAlign: "center",
                        color: Color.lightgrey,
                      },
                    ]}
                  >
                    {globalConfigurableData.appName} is currently unavailable due to site
                    maintainence.
                    {"\n"}
                    Please check back later.
                  </Text>
                </View>
              </View>
              <View
                style={{
                  position: "absolute",
                  bottom: 0,
                  paddingBottom: 45,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={[
                    globalFontStyle.appFontSubText,
                    {
                      textAlign: "center",
                      color: Color.lightgrey,
                    },
                  ]}
                >
                  If you require help, please contact us at:
                </Text>
                <Text
                  style={[
                    globalFontStyle.appFontSubText,
                    {
                      textAlign: "center",
                      color: Color.tradexBlue,
                    },
                  ]}
                >
                  help@tradexapp.co
                </Text>
              </View>
            </View>
          );
        }}
        refreshing={false}
        onRefresh={handleRefresh}
      />
    </SafeAreaView>
  );
};

export default Maintanence;
